import React, { useState, useEffect } from 'react'

import QuickDualDatePickers from '../shared/QuickDualDatePickers'
import { Card } from 'antd'
import { faBan, faEdit, faSave, faTrash } from '@fortawesome/pro-solid-svg-icons'
import GlobalPlacesForm from './forms/GlobalPlacesForm'
import { BACKEND_DATE_FORMAT } from '../../../../utils/constants'
import { POPOVER_CONTENT } from './QuotaCard'
import moment from 'moment'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { isFunction } from 'lodash'
import TooltipIconButton from '../../../antd/Buttons/TooltipIconButton'
import PopoverIconButton from '../../../antd/Buttons/PopoverIconButton'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const EditableQuotaCard = ({ quota, onDelete, onSave, t }) => {
  const [localQuota, setLocalQuota] = useState(null)
  const [previousQuota, setPreviousQuota] = useState(null)
  const [editionMode, setEditionMode] = useState(false)

  useEffect(() => {
    if (quota) {
      setLocalQuota(quota)
    }
  }, [quota, setLocalQuota])

  const handleEdition = () => {
    setEditionMode(true)
    setPreviousQuota({ ...localQuota })
  }

  const handleSuppression = () => {
    if (isFunction(onDelete)) {
      onDelete(quota)
    }
  }

  const handleEditionCanceled = () => {
    setEditionMode(false)
    setLocalQuota({ ...previousQuota })
    setPreviousQuota(null)
  }

  const handleSaving = () => {
    setEditionMode(false)
    setPreviousQuota(null)

    if (isFunction(onSave)) {
      onSave(localQuota)
    }
  }

  const updateQuotaPlaces = newPlaces => {
    setLocalQuota({ ...localQuota, total: newPlaces })
  }

  const updateQuotaDates = dates => {
    const newQuota = { ...localQuota }

    newQuota.startDate = dates[0].format(BACKEND_DATE_FORMAT)
    newQuota.endDate = dates[1].format(BACKEND_DATE_FORMAT)

    setLocalQuota(newQuota)
  }

  const getCardActions = () => {
    if (editionMode) {
      return (
        [
          <TooltipIconButton
            key='card-save-button'
            title={t('Save')}
            onClick={handleSaving}
            icon={faSave}
          />,
          <TooltipIconButton
            key='card-cancel-button'
            title={t('Cancel')}
            onClick={handleEditionCanceled}
            icon={faBan}
          />
        ]
      )
    }

    return ([
      <TooltipIconButton
        key='card-edit-button'
        title={t('Edit')}
        onClick={handleEdition}
        icon={faEdit}
      />,
      <PopoverIconButton
        key='card-trash-button'
        title={t('Delete')}
        tooltipTitle='Delete'
        content={POPOVER_CONTENT}
        onConfirm={handleSuppression}
        icon={faTrash}
      />
    ])
  }

  const renderBody = () => {
    return (
      <div className='allocation-quota-card-body'>
        <QuickDualDatePickers
          startDate={localQuota ? moment(localQuota.startDate) : moment()}
          endDate={localQuota ? moment(localQuota.endDate) : moment()}
          onDatesChange={updateQuotaDates}
          disabled={!editionMode}
        />
        <GlobalPlacesForm
          places={localQuota ? localQuota.total : 0}
          onPlacesChanged={updateQuotaPlaces}
          disabled={!editionMode}
        />
      </div>
    )
  }

  return (
    <Card
      style={{ width: '100%' }}
      actions={getCardActions()}
    >
      {renderBody()}
    </Card>
  )
}

export default connect(mapStateToProps)(EditableQuotaCard)
